<template>
  <div class="flex flex-col items-start">
    <social-button name="twitter" class="bg-blue-light text-white mb-5"></social-button>
    <social-button name="facebook" class="bg-blue-dark text-white mb-5"></social-button>
    <social-button name="linkedin" class="bg-blue-darker text-white mb-5"></social-button>
    <social-button name="youtube" class="bg-red text-white mb-5"></social-button>

    <modal>
      <video-share :videoId="1" />
    </modal>

  </div>
</template>

<style lang="sass" scoped>

</style>

<script>
import SocialButton from '@/components/SocialButton'
import VideoShare from '@/components/VideoShare'

export default {
  name: 'Social',
  components: {
    SocialButton,
    VideoShare
  }
}
</script>
